import './ChartLegend.scss';
import { prefixClass } from 'lib/utils';
import { ChartGroup, ChartProps } from '../../types';
import { useChartContext } from '../../context/ChartContext';
import classNames from 'classnames';

const ChartLegend = ({ data }: { data: ChartProps | null }) => {
  const prefix = prefixClass('chart-legend');
  const { filters, chartFilters } = useChartContext();

  // If no data, don't render anything
  if (!data) return null;

  // Chart filters are managed by ChartContext

  const legendItem = (group: ChartGroup, type: string) => (
    <div className={classNames(prefix('group-item'), `legend-${group.toLocaleLowerCase()}`)}>
      <div
        className={classNames(
          prefix(`group-item-artifact-${type === '%' ? 'dot' : 'box'}`),
          `legend-${group.toLocaleLowerCase()}`
        )}
      ></div>
      <div>{type}</div>
    </div>
  );

  return (
    <div className={prefix()}>
      {chartFilters.groups.map((group: ChartGroup, index: number) => (
        <div key={index} className={prefix('group')}>
          {chartFilters.money && legendItem(group, '$')}
          {chartFilters.percent && legendItem(group, '%')}
          {group}
        </div>
      ))}
    </div>
  );
};

export default ChartLegend;
